import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

// Display all Branch List
export const getBranchList = createAsyncThunk('data/Branch',
    async(data)=>{
      const res = await axiosInstance.get(`/api/v1/getofficebranches?page=${data.page}&limit=${data.limit}`);
        return res.data
    }
)

//Create Branch Details
export const createBranchDetails = createAsyncThunk('data/createBranch',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/officebranches', data);
      return res.data
  }
)

//Update Branch Details
export const updateBranchDetails = createAsyncThunk('data/updateBranch',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/updateofficebranches', data);
      return res.data
  }
)

//Delete Branch Details
export const deleteBranchDetails = createAsyncThunk('data/deleteBranchDetails',
  async(data)=>{
    const res = await axiosInstance.delete(`/api/v1/deleteofficebranches/${data}`);
      return res.data
    }
)